module.exports = __webpack_public_path__ + "static/media/skolen.e65fef63.png";